import ResponsiveComponent from './ResponsiveComponent'

export default ResponsiveComponent
